export const CREATE_FCN_QUERY = "CREATE@FCN_QUERY";
export const CREATE_FCN_QUERY_INIT = "CREATE@FCN_QUERY_INIT";
export const CREATE_FCN_QUERY_SUCCESS = "CREATE@FCN_QUERY_SUCCESS";
export const CREATE_FCN_QUERY_FAILED = "CREATE@FCN_QUERY_FAILED";
